import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addInventory } from "../../api/inventory.api";
import { toast } from "react-toastify";
import { inventoryKeys } from "../../queryKeys";

export const useAddInventory = () => {

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ qty, productId }: { qty: number; productId: string }) =>
      addInventory(qty, productId),

    onSuccess: (res, variables) => {
      if (res?.message?.toLowerCase() === "success") {
        toast.success("Stock Updated");

        // invalidate inventory query
        queryClient.invalidateQueries({
          queryKey: [...inventoryKeys.all, variables.productId],
        });
      } else {
        toast.error("Failed to add stock!");
      }
    },

    onError: (error) => {
      toast.error("Failed to add stock!");
      console.error("failed to add stock", error);
    },
  });
};